query ListTags($catNumber: String, $offset: Int, $limit: Int) {
  listTags(catNumber: $catNumber, offset: $offset, limit: $limit) {
    hasMore
    results {
      catNumber
      locationDates {
        dateRange {
          endDate
          startDate
        }
        states
        type
      }
      name
      openlyDateRange {
        endDate
        startDate
      }
      openlyOnlyStates
      pcsDateRange {
        endDate
        startDate
      }
      pcsStates
      perils {
        name
        uuid
      }
      tagUuid
      type
      vendorId
      vendorName
    }
  }
}
